<header>
  <h2>{{ 'CreateLotItem.title' | translateWF: 'Create Lot Item' }}</h2>
</header>

<section class="content">
  <form [formGroup]="form" class="flex flex-col gap-4">
    <div class="form-field">
      <label for="productDevelopmentNumber">{{ 'CreateLotItem.product_development_number' | translateWF: 'Product Development Number' }}</label>
      <input id="productDevelopmentNumber" pInputText [value]="productDevelopmentNumber" disabled class="w-full" />
    </div>

    <div class="form-field">
      <label for="packagingType">{{ 'CreateLotItem.packaging_type' | translateWF: 'Packaging Type' }} *</label>
      <p-select
        inputId="packagingType"
        formControlName="packagingType"
        [options]="packagingOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        class="w-full"
        styleClass="w-full"
      />
    </div>

    <div class="form-field">
      <label for="netQuantity">{{ 'CreateLotItem.net_quantity' | translateWF: 'Net Quantity (kg)' }} *</label>
      <p-inputNumber inputId="netQuantity" formControlName="netQuantity" [min]="0.01" mode="decimal" [minFractionDigits]="2" suffix=" kg" styleClass="w-full" placeholder="0.00" />
    </div>

    <div class="form-field">
      <label for="grossQuantity">{{ 'CreateLotItem.gross_quantity' | translateWF: 'Gross Quantity (kg)' }} *</label>
      <p-inputNumber
        inputId="grossQuantity"
        formControlName="grossQuantity"
        [min]="0.01"
        mode="decimal"
        [minFractionDigits]="2"
        suffix=" kg"
        styleClass="w-full"
        placeholder="0.00"
      />
      @if (form.hasError('grossBelowNet') && form.controls.grossQuantity.dirty) {
        <small class="p-error">{{ 'CreateLotItem.gross_below_net' | translateWF: 'Gross quantity cannot be less than net quantity' }}</small>
      }
    </div>
  </form>
</section>

<footer>
  <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (onClick)="onClose()" />
  <p-button
    [label]="'CreateLotItem.create' | translateWF: 'Create'"
    icon="pi pi-plus"
    (onClick)="onSave()"
    [loading]="isLoading() > 0"
    [disabled]="form.invalid || isLoading() > 0"
  />
</footer>
